import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@environment/environment";
import jwt_decode from 'jwt-decode';
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import { BehaviorSubject, Observable, lastValueFrom, tap } from "rxjs";
import { TenantService } from "./tenant.service";

const gateway = environment.config.apiUrl;


@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private isLoaded$$: BehaviorSubject<boolean>;

  private loggedIn$$: BehaviorSubject<boolean>;
  private loggedIn$$$: BehaviorSubject<boolean>;// intermediario para tratar afterLoginSync e afterLoginAsync
  private claims: any[] = [];
  private user_routines: any[] = [];

  constructor(
    private http: HttpClient,
    private sessionStorage: SessionStorageService,
    private localStorage: LocalStorageService,
    private tenantService: TenantService,
  ) {
    this.isLoaded$$ = new BehaviorSubject(false);

    this.loggedIn$$ = new BehaviorSubject(this.isLoggedIn());
    this.loggedIn$$$ = new BehaviorSubject(false); // intermediario para tratar afterLoginSync e afterLoginAsync

    this.loggedIn$$
      .subscribe(async (r) => {
        if (r) {
          this.afterLoginAsync();
          await this.afterLoginSync();
          this.loggedIn$$$.next(true);
        }
        this.isLoaded$$.next(true);
      });

  }

  isLoaded$(): Observable<boolean> {
    return this.isLoaded$$.asObservable();
  }

  isLoggedIn$(): Observable<boolean> {
    //return this.loggedIn$$.asObservable();
    return this.loggedIn$$$.asObservable();
  }

  async fetchClaims() {

    const url = `${gateway}/auth/claims`;
    await lastValueFrom(this.http.get(url))
      .then((resp: any) => {
        this.claims = [...resp];
        console.log("===========", "Claims fetched.");
      })
      .catch((err) => {
        console.log("===========", "Claims error.");
        console.log(err);
      });


  }

  async fetchModules() {

    const userId = this.sessionStorage.retrieve('userId');
    const url = `${gateway}/u/${userId}/modules`;

    await lastValueFrom(this.http.get(url))
      .then((resp: any) => {
        this.user_routines = [...resp];
        console.log("===========", "Modules fetched.");
      })
      .catch((err) => {
        console.log("===========", "Modules error.");
        console.log(err);
      });

  }

  authorize(rights: string | string[]): boolean {

    const token = this.getUserToken();
    const decoded: any = jwt_decode(token);
    const hash = +decoded[environment.jwt.aud].claims_hash;

    const claims = [];
    if (!Array.isArray(rights)) {
      claims.push(rights);
    }
    else {
      for (let index = 0; index < rights.length; index++) {
        const element = rights[index];
        claims.push(element);
      }
    }


    let ret: boolean = true;

    for (const right of claims) {

      const claim = this.claims.find(r => r.id == right);
      if (!claim){
        ret = false;
        continue;
      }

      const claimValue = 1 << claim.value;

      ret = ret && (!!(claimValue & hash));
    }    

    return ret;

  }

  getAgentId(): string {
    return this.sessionStorage.retrieve('agentId');
  }

  getUserRoutines() {
    return this.user_routines;
  }


  getUserId(): string {
    return this.sessionStorage.retrieve('userId') ?? '';
  }

  logout(): void {
    this.deleteToken();
    this.loggedIn$$.next(false);
    this.loggedIn$$$.next(false);
  }

  login(email: string, password: string): Observable<any> {

    const tenant = this.tenantService.getActiveTenant();
    const url = `${gateway}/auth/login`;
    return this.http.post(
      url,
      { email, password, tenant }
    )
      .pipe(
        //delay(5000),
        tap(async (response) => {
          this.saveToken(response); //salva o toke primeiro para usar nas req subsequentes          
          this.loggedIn$$.next(true);
        }),

      );
  }

  register(full_name: string, email: string, password: string, eula: any[], affiliate_code: string = ""): Observable<any> {

    const tenant = this.tenantService.getActiveTenant();
    const url = `${gateway}/auth/create-account`;
    return this.http.post(
      url,
      {
        full_name,
        email,
        password,
        tenant,
        affiliate_code,
        eula
      }
    );


  }

  resetPassword_req(email: string): Observable<any> {

    const tenant = this.tenantService.getActiveTenant();
    const url = `${gateway}/auth/reset-password`;
    return this.http.post(
      url,
      { email, tenant }
    );
  }

  resetPassword_resp(email: string, password: string, token: string): Observable<any> {

    const tenant = this.tenantService.getActiveTenant();
    const url = `${gateway}/auth/reset-password`;
    return this.http.put(
      url,
      { email, password, tenant, token }
    );
  }


  validateOperationToken(token: string, operation: string): boolean {
    let ret = false;

    try {

      const decoded: any = jwt_decode(token);
      const tokenOperation = decoded.operation;

      ret = operation === tokenOperation;


    } catch (error) {
      console.log(error);

    }


    return ret;
  }


  getOperationTokenPayload(token: string): any {
    let ret = {};

    try {

      const decoded: any = jwt_decode(token);

      ret = decoded


    } catch (error) {
      console.log(error);

    }


    return ret;
  }


  // privates
  /* ********************************************************************* */
  private isLoggedIn() {
    if (this.hasSavedToken()) {
      const token = this.getUserToken();
      const decoded: any = jwt_decode(token);
      const expiryMilis = Number(decoded.exp) * 1000;
      const nowMilis = new Date().getTime();

      const storedAgentId = this.getAgentId();
      const tokenAgentId = decoded[environment.jwt.aud].agent_id;

      const tokenOk = (nowMilis <= expiryMilis) && (storedAgentId == tokenAgentId);

      return tokenOk;

    }
    return false;
  }

  private hasSavedToken(): boolean {
    return Boolean(this.sessionStorage.retrieve('userToken'));
  }

  private getUserToken(): string {
    return this.sessionStorage.retrieve('userToken') ?? '';
  }

  //rotinas que rodam em paralelo depois do login
  private async afterLoginAsync() {
    //this.createPlatformToken();
  }

  //rotinas que rodam em serie depois do login
  private async afterLoginSync() {
    await this.fetchClaims();
    await this.fetchModules();
  }

  private createPlatformToken(): void {

    // if (Boolean(this.sessionStorage.retrieve('platformToken')))
    //   return;

    // const url = `${gateway}/auth/service-login`;
    // this.http.post<CommonResponse>(
    //   url,
    //   JSON.stringify({}),
    //   { headers: { 'x-app-service': 'front_web' } }
    // )
    //   .toPromise()
    //   .then(resp => {
    //     this.sessionStorage.store('platformToken', resp.object.token);
    //   });

  }

  private deleteToken(): void {
    this.sessionStorage.clear('userToken');
    this.sessionStorage.clear('userId');
  }

  private saveToken(loginResponse: any): void {

    const decoded: any = jwt_decode(loginResponse.token || '');
    const userId = decoded[environment.jwt.aud].user_id;

    this.sessionStorage.store('userToken', loginResponse.token);
    this.sessionStorage.store('userId', userId);

  }
  /* ********************************************************************* */



}

